import { render, staticRenderFns } from "./RecommendEntrance.vue?vue&type=template&id=97392070&scoped=true"
import script from "./RecommendEntrance.vue?vue&type=script&lang=js"
export * from "./RecommendEntrance.vue?vue&type=script&lang=js"
import style0 from "./RecommendEntrance.vue?vue&type=style&index=0&id=97392070&prod&lang=scss&scoped=true"
import style1 from "./RecommendEntrance.vue?vue&type=style&index=1&id=97392070&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97392070",
  null
  
)

export default component.exports